import { render } from "./InstrumentsSection.vue?vue&type=template&id=728a6c32&scoped=true"
import script from "./InstrumentsSection.vue?vue&type=script&lang=js"
export * from "./InstrumentsSection.vue?vue&type=script&lang=js"

import "./InstrumentsSection.vue?vue&type=style&index=0&id=728a6c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728a6c32"]])

export default __exports__